export enum EmailTypes {
  Personal = "personal",
  Principal = "principal",
}
